module.exports = "query GetCampaignOrders($id: ID!) {\n  campaign(id: $id) {\n    orders {\n      ...DetailedOrderFragment\n    }\n  }\n}\n"